import { Property } from '../models/Property';

export class PropertyProxy {
    static formatForUI(property: Property, language: string) {
        return {
            id: property.id,
            title: property.title || 'No Title',
            description: property.description || '',
            address: property.location?.address || '',
            price_daily: property.pricing?.daily,
            price_monthly: property.pricing?.monthly,
            price_yearly: property.pricing?.yearly,
            is_active: property.is_active,
            rooms: property.features?.rooms || 0,
            status: property.is_active ? 'available' : 'maintenance',
            image: property.main_image?.url || 'https://via.placeholder.com/400x300',
            owner: {
                name: property.owner?.name || 'Owner Not Found',
                phone: property.owner?.phone || ''
            },
            created_at: property.created_at ? new Date(property.created_at).toLocaleDateString() : 'N/A'
        };
    }

    static formatListForUI(properties: Property[], language: string) {
        if (!Array.isArray(properties)) return [];
        return properties.map(p => this.formatForUI(p, language));
    }
}
